import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Fancybox as NativeFancybox } from '@fancyapps/ui';
import FilePlaceholder from './placeholder/FilePlaceholder';
import { Fancybox } from './Fancybox';
import TooltipOverlay from './tooltip/Tooltip';
import { getTruncatedData } from '../../utils/helpers/getTruncatedData';
import { downloadFile, formatDate } from '../functions/Functions';

interface ICancellationInfoProps {
    note?: string | null;
    documentName?: string | null;
    documentPath?: string | null;
    documentUploadedAt?: string | null;
}

export function CancellationInfo({ note, documentName, documentPath, documentUploadedAt }: ICancellationInfoProps) {
    const { t } = useTranslation();

    if (!note && !documentPath) {
        return null;
    }

    const fileName = documentName ?? '';
    const { truncatedName, isTruncated } = getTruncatedData(fileName, 30);
    const file = {
        mime: 'application/pdf',
        name: documentPath ?? fileName,
        originalName: fileName,
        path: documentPath,
    };

    return (
        <div className="mb-3">
            <Card className="border-danger">
                <Card.Body>
                    <h5 className="ml-2 mb-3">{t('brand.campaign.book.offer.cancellation_reason')}</h5>
                    {note && (
                        <div className="default-border-lighter default-radius mb-3">
                            <p className="p-2 mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                                {note}
                            </p>
                        </div>
                    )}
                    {documentPath && (
                        <div
                            className="d-flex align-items-start p-2 border rounded position-relative"
                            style={{ maxWidth: 300 }}
                        >
                            <Fancybox>
                                <FilePlaceholder
                                    file={file}
                                    hideText={true}
                                    classIcon="font-22"
                                    styleContent={{ width: 40, height: 40, flexShrink: 0 }}
                                    nameFancybox="cancellation-document"
                                    handleDownload={() => downloadFile(documentPath, fileName)}
                                    right={-10}
                                />
                            </Fancybox>
                            <div className="ms-2">
                                <TooltipOverlay content={isTruncated ? fileName : ''}>
                                    <p
                                        className="mb-0 fw-semibold cursor-pointer"
                                        onClick={() => NativeFancybox.show([{ src: documentPath, type: 'iframe' }])}
                                    >
                                        {truncatedName || t('brand.campaign.book.offer.cancellation_document')}
                                    </p>
                                </TooltipOverlay>
                                {documentUploadedAt && (
                                    <p className="mb-0 text-muted fs-12">
                                        {t('influencer.offer_management.modal.uploaded_at')}:{' '}
                                        {formatDate(documentUploadedAt)}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
}
